import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import PageIntroBanner from '../../components/PageIntroBanner';
import InsideHeader from '../../components/InsideHeader';
import PageHelmet from '../../components/PageHelmet';
import MenuAbout from '../../components/MenuAbout';
import { colors } from '../../styles';

const styles = css`
  .Testimonials_wrapper {
    padding: 40px 15px;
    @media(min-width: 768px) {
      padding: 90px 0;
    }

    .Testimonials_welcome {
      font-weight: 400;
      font-size: 21px;
      text-align: center;
      margin: 0 0 45px 0;
      @media(min-width: 992px) {
        font-size: 36px;
      }
    }
  }
  .Button_wrapper {
    display: flex;
    justify-content: center;
    .ButtonDefault {
      cursor: pointer;
    }
  }

  .Testimonials_listWrapper {
    columns: 1;
    column-gap: 30px;
    @media(min-width: 768px) {
      columns: 2;
    }
    @media(min-width: 992px) {
      columns: 3;
    }

    .TestimonialResult {
      display: inline-block;
      transition: all .3s ease-out;
      box-shadow: 0 1.5px 1.5px 0 rgba(0,0,0,.15);
      margin-bottom: 30px;
      padding: 30px;
      border: 1px solid ${colors.whiteDarker};
      @media(min-width: 992px) {
      }
      @media(min-width: 1200px) {
      }
      @media(min-width: 1400px) {
      }

      .card {
        border-radius: 0;
      }


      &:hover {
        box-shadow: 0 3.5px 7.5px 0 rgba(0,0,0,.25);
        transition: all .3s ease-out;
      }
      p {
        font-size: 17px;
        line-height: 34px;
        font-weight: 300;
        padding-bottom: 0;
        text-align: center;
      }
      h4 {
        text-align: center;
        font-weight: 600;
        font-size: 21px;
      }
    }
  }
`;

class Testimonials extends React.Component {
  constructor(props) {
    super(props);

    const increment = 5;
    this.state = {
      increment,
      limit: increment,
    };

    this.showMore = this.showMore.bind(this);
  }

  showMore() {
    this.setState({
      limit: this.state.limit + Infinity,
    });
  }
  render() {
    const { page } = this.props;
    return (
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuAbout />
        <div className={styles}>
          <PageIntroBanner
            headline={get(page, 'page_intro_banner[0].headline')}
            body={get(page, 'page_intro_banner[0].text')}
            image={get(page, 'page_intro_banner[0].photo.contentUrl')}
            videoThumbnail={get(page, 'page_intro_banner[0].video_thumbnail.contentUrl')}
            video={get(page, 'page_intro_banner[0].video_embed_code')}
          />
          <div className="container">
            <div className="Testimonials_wrapper">
              <div className="Testimonials_welcome" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'testimonial_section_heading'))} />
              <div className="Testimonials_listWrapper card-columns">
                {
                  get(page, 'testimonials').map(testimonial => (
                    <div className="TestimonialResult card" key={testimonial._id}>
                      <p>{get(testimonial, 'description')}</p>
                      <h4>{get(testimonial, 'name')}</h4>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

Testimonials.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'testimonials',
})(Testimonials);



// WEBPACK FOOTER //
// ./src/pages/Testimonials/index.js